import { FETCH_COMMENT_CATEGORIES } from 'actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_COMMENT_CATEGORIES:
            return action.payload;
        default:
            return state;
    }
};